import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../base_svg-icon/component';
import Link from '../base_link/component';
import Text from '@text';

import './styles/styles.scss';

const Breadcrumb = (props) => {
  const { items = [], showBackButton } = props;

  const handleBackButton = () => {
    const targetitem = items[items.length - 2];
    if (targetitem.callback) {
      targetitem.callback();
    }
  };

  const renderBackButton = () => {
    if (items.length < 2) {
      return null;
    }
    return (
      <button className="go-back" onClick={handleBackButton}>
        <Icon name="ico-arrow-left" />
        <span>
          <Text>search.result.breadcrumb.back</Text>
        </span>
      </button>
    );
  };

  const renderBackCrumb = () => {
    if (!items.length >= 2) {
      return null;
    }
    const item = items[items.length - 2] || {};

    if (item.url) {
      return (
        <li className="breadcrumb__item back visible-xs">
          <Link onClick={item.callback} to={item.url} className="breadcrumb__link">
            <span className="seperator">
              <Icon name="ico-arrow-left" size={87}/>
            </span>
            <Text>search.result.breadcrumb.back</Text>
          </Link>
        </li>
      );
    }

    if (showBackButton) {
      return null;
    }

    return (
      <li className="breadcrumb__item back visible-xs">
        <span onClick={item.callback} className="breadcrumb__link">
          <span className="seperator">
            <Icon name="ico-arrow-left" size={87}/>
          </span>
          <Text>search.result.breadcrumb.back</Text>
        </span>
      </li>
    );
  };

  const renderItem = (item) => {
    const { callback, url, name } = item;
    const testId = `breadcrumb-${name.replace(/[^a-zA-Z0-9]/g, ' ').split(/\s+/)
      .join('-')
      .toLowerCase()}`;

    if (url) {
      return (
        <Link onClick={callback} to={url} className="breadcrumb__link" data-test-id={testId}>{name}</Link>
      );
    }

    if (callback) {
      return (
        <span onClick={callback} className="breadcrumb__link" data-test-id={testId}>{name}</span>
      );
    }

    return name;
  };

  return (
    <ul className="breadcrumb breadcrumb-list" data-test-id="component-breadcrumbs">
      {showBackButton && renderBackButton()}
      {items?.map((item, i) => {
        const isLastCrumb = i + 1 === items.length;

        return (
          <li className={`breadcrumb__item hidden-xs ${isLastCrumb ? 'disabled' : ''}`} key={i}>
            <span className="seperator">
              <Icon name="ico-arrow-right" size={87}/>
            </span>
            {renderItem(item)}
          </li>
        );
      })}
      {renderBackCrumb()}
    </ul>
  );
};


Breadcrumb.propTypes = {
  /**
   * Breadcrumb items
   */
  items: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
    url: PropTypes.string,
    callback: PropTypes.func,
  })),
  showBackButton: PropTypes.bool,

};

export default Breadcrumb;
